import { useQuery } from '@tanstack/react-query';
import { expertTipApi } from '../services/adminApi';
import { queryKeys } from '../utils/queryKeys';

/** Domains and skills for the tip form and list filters (open to every admin role) */
export function useExpertTipFilterOptions() {
  return useQuery({
    queryKey: queryKeys.expertTips.filterOptions(),
    queryFn: () => expertTipApi.getFilterOptions(),
    staleTime: 5 * 60 * 1000,
  });
}
